// extracted by mini-css-extract-plugin
module.exports = {"button":"LandingAccordion_button__pv4PA","proposal":"LandingAccordion_proposal__xzQGu","liveBtn":"LandingAccordion_liveBtn__FHddQ","view":"LandingAccordion_view__syWhW"};